module.exports = __webpack_public_path__ + "76180a5198d66ff32a1ec2fb4d3338eb.svg";